import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Animation1Gif from "@images/game-pass/animation_1.gif";
import Animation2Gif from "@images/game-pass/animation_2.gif";
import Animation3Gif from "@images/game-pass/animation_3.gif";
import Animation4Gif from "@images/game-pass/animation_4.gif";
import Animation5Gif from "@images/game-pass/animation_5.gif";
import Animation6Gif from "@images/game-pass/animation_6.gif";

const FirstImageSlider = () => {

  function SampleNextArrow(props) {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{ ...style, display: "block", background: "red" }}
        onClick={onClick}
      />
    );
  }
  
  function SamplePrevArrow(props) {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{ ...style, display: "block", background: "green" }}
        onClick={onClick}
      />
    );
  }

  const settings = {
    className: "center",
    infinite: true,
    centerPadding: "60px",
    slidesToShow: 3,
    swipeToSlide: true,
    arrows: false,
    dots: false,
    autoplay: true,
    speed: 7000,
    cssEase: "linear",
    centerMode: true,
    autoplaySpeed:  0,
    rtl: true,
  };

  return (
    <div className="flex flex-col w-full">
      <Slider {...settings}>
        <div>
          <img src={Animation6Gif} className='xl:w-[800px] w-[664px] max-h-[374px] px-[6px] rounded-[19.166px]' alt="animation-1" />
        </div>
        <div>
          <img src={Animation5Gif} className='xl:w-[800px] w-[664px] max-h-[374px] px-[6px] rounded-[19.166px]' alt="animation-1" />
        </div>
        <div>
          <img src={Animation4Gif} className='xl:w-[800px] w-[664px] max-h-[374px] px-[6px] rounded-[19.166px]' alt="animation-1" />
        </div>
        <div>
          <img src={Animation3Gif} className='xl:w-[800px] w-[664px] max-h-[374px] px-[6px] rounded-[19.166px]' alt="animation-1" />
        </div>
        <div>
          <img src={Animation2Gif} className='xl:w-[800px] w-[664px] max-h-[374px] px-[6px] rounded-[19.166px]' alt="animation-1" />
        </div>
        <div>
          <img src={Animation1Gif} className='xl:w-[800px] w-[664px] max-h-[374px] px-[6px] rounded-[19.166px]' alt="animation-1" />
        </div>
      </Slider>
    </div>
  );
};

export default FirstImageSlider;